// assets
import {
  IconUsers,
  IconFileStack,
  IconSubtask,
  IconPlaylistAdd,
  IconUserSearch,
  IconFileDatabase,
  IconDatabase,
  IconFile,
  IconUserPlus,
  IconCategory,
  IconChecklist,
  IconDatabaseExport
} from '@tabler/icons';

// constant
const icons = {
  IconFileStack,
  IconSubtask,
  IconUsers,
  IconPlaylistAdd,
  IconUserSearch,
  IconFileDatabase,
  IconDatabase,
  IconFile,
  IconUserPlus,
  IconCategory,
  IconChecklist,
  IconDatabaseExport
};

// const [id]
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const AdminUtils = {
  id: 'utilities',
  title: 'Menu Items',
  icon:icons.IconCategory,
  display_id: 'A',
  type: 'group',
  children: [
    {
      id: 'product master',
      title: 'Product Master',
      type: 'item',
      display_id: 1,
      url: '/Admin/AddProduct',
      icon: icons.IconFileStack,
      breadcrumbs: false
    },
    {
      id: 'field master',
      title: 'Field Master',
      type: 'item',
      display_id: 2,
      url: '/Admin/AddDP',
      icon: icons.IconSubtask,
      breadcrumbs: false
    },
    {
      id: 'category',
      title: 'Category Setup',
      type: 'item',
      display_id: 3,
      url: '/Admin/Categorysetup',
      icon: icons.IconCategory,
      breadcrumbs: false
    },
    {
      id: 'access management',
      title: 'Access Management',
      type: 'item',
      display_id: 4,
      url: '/Admin/AccessManagement',
      icon: icons.IconPlaylistAdd,
      breadcrumbs: false
    },
    {
      id: 'Manage group',
      title: 'Manage Group',
      type: 'item',
      display_id: 5,
      url: '/Admin/CreateGroup',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: 'View groups',
      title: 'View Groups',
      type: 'item',
      display_id: 6,
      url: '/Admin/ViewAllAccess',
      icon: icons.IconUserSearch,
      breadcrumbs: false
    },
    {
      id: 'View add points',
      title: 'View MDM',
      type: 'item',
      display_id: 7,
      url: '/Admin/ViewDatapoints',
      icon: icons.IconDatabaseExport,
      breadcrumbs: false
    },
    {
      id: 'View Products',
      title: 'View Products',
      type: 'item',
      display_id: 8,
      url: '/Admin/ViewProducts',
      icon: icons.IconDatabase,
      breadcrumbs: false
    }
  ].filter(Boolean)
};
export default AdminUtils;
